exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subOption[data-v-390e4f49] {\n  font-size: 14px;\n}\n.subOption input[data-v-390e4f49]::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.label-switch[data-v-390e4f49] {\n  float: right;\n}\n.no-bullets[data-v-390e4f49] {\n    list-style-type: none;\n}\n.mt-2[data-v-390e4f49] {\n  width: 100%;\n}\n.inputFileButton[data-v-390e4f49] {\n  float: left;\n}\n.list-block[data-v-390e4f49] {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n.button-setting[data-v-390e4f49] {\n  width: 80px;\n}\nul[data-v-390e4f49] {\n  margin-left: -35px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-390e4f49","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMApplicationSettingsPage.vue
// module id = 1571
// module chunks = 2